
import { isMobile } from 'react-device-detect';
import { Tooltip } from 'react-tooltip';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import styled from 'styled-components';

import info_chip from '../../../../../../assets/info_chip.svg';
import premium_check_icon from '../../../../../../assets/premium_check.svg';

import './styles.css';

const FEATURES = [
  'All Images Unblurred',
  'Secret Scenarios: 5x More Content',
  'No Message Limits',
  'Faster Responses',
  'Advanced AI',
  'Customization'
];

interface IIconProps {
  src: string;
}

interface IOfferDescriptionSectionProps {
  isExpiredSub: boolean;
  isExpandedPremiumOfferSection: boolean;
  onExpandedPremiumOfferSection: () => void;
}

interface IOfferDescriptionProps {
  isExpiredSub: boolean;
  children: React.ReactNode;
  onClick: () => void;
}

interface IChevronContainerProps {
  isExpanded: boolean;
  children?: React.ReactNode;
}

const OfferDescriptionSection: React.FC<IOfferDescriptionSectionProps> = (props) => {
  const { isExpiredSub, isExpandedPremiumOfferSection, onExpandedPremiumOfferSection } = props;

  const handleChevronClick = () => isMobile ? onExpandedPremiumOfferSection() : null;

  return (
    <OfferDescription onClick={handleChevronClick} isExpiredSub={isExpiredSub}>
      <OfferDescriptionInner>
        <OfferDescriptionText>Please update your payment details
          to keep enjoying <PremiumDescription>premium features</PremiumDescription></OfferDescriptionText>

        {isMobile && isExpandedPremiumOfferSection && (
          <FeaturesWrapper>
            {
              FEATURES.map((feature) => (
                <>
                  <div key={feature} className="flex items-center space-x-3">
                    <ItemImage src={premium_check_icon} />
                    <Text>{feature}</Text>
                  </div>
                </>
              ))
            }
          </FeaturesWrapper>
        )}
      </OfferDescriptionInner>
      {!isMobile && (
        <InfoChip src={info_chip} data-tooltip-id={'info_chip'} />
      )}

      {isMobile && <ChevronContainer isExpanded={isExpandedPremiumOfferSection} >
        <ChevronDownIcon className="h-4 w-4" />
      </ChevronContainer>}

      <Tooltip
        id="info_chip"
        place="bottom-end"
        className="offerBannerTooltipContainer"
        opacity={1}
        // @ts-ignore
        content={
          <FeaturesWrapper>
            {FEATURES.map((feature, index) => (
              <>
                {index === 0 && <PremiumTooltipDescription>Premium Features:</PremiumTooltipDescription>}
                <div key={feature} className="flex items-center space-x-3">
                  <ItemImage src={premium_check_icon} />
                  <Text>{feature}</Text>
                </div>
              </>
            ))}
          </FeaturesWrapper>
        }
      />

    </OfferDescription>
  );
};

export default OfferDescriptionSection;


const OfferDescription = styled.div<IOfferDescriptionProps>`
  font-family: Nunito Sans;
  font-size: 16px;
  font-weight: 400;
  line-height: 18px;
  color: #A9A9A9;
  background: linear-gradient(90deg, rgba(158, 94, 238, 0.15) 0%, rgba(183, 89, 234, 0.15) 32%, rgba(198, 93, 233, 0.15) 66%, rgba(184, 133, 244, 0.15) 100%);
  padding: 12px 16px;
  border: 1px solid rgba(158, 94, 238, 1);
  border-radius: 12px;
  position: relative;
  max-height: 64px;
  min-height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom:  ${({ isExpiredSub }) => isExpiredSub ? '0px' : '20px'};

  @media (max-width: 768px) {
    max-height: unset;
    min-height: auto;
  }
`;


const OfferDescriptionInner = styled.div`
  max-width: 80%;

  @media (max-width: 768px) {
    max-width: 90%;
  }
`;

const OfferDescriptionText = styled.span`
  font-family: Nunito Sans;
  font-size: 18px;
  font-weight: 700;
  line-height: 20px;
  color: white;

  @media (max-width: 820px) {
    font-size: 16px;
  }

  @media (max-width: 768px) {
    padding: 12px 0;
    font-size: 16px;
  }

  @media (max-height: 700px) {
    font-size: 14px;
  }

`;

const PremiumDescription = styled.span`
  background: linear-gradient(90deg, #9e5eee 0%, #b759ea 32%, #c65de9 66%, #b885f4 100%);
  background-clip: text;
  color: transparent;
}`;

const PremiumTooltipDescription = styled(PremiumDescription)`
  font-size: 18px;
  font-weight: 700;
  line-height: 20px;
`;

const InfoChip = styled.img<IIconProps>`
  width: 24px;
  height: fit-content;
  cursor: pointer;
`;

const ItemImage = styled.img<IIconProps>`
  width: 18px;
  height: 18px;
`;

const Text = styled.span`
  font-family: Nunito Sans;
  font-size: 16px;
  font-weight: 400;
  line-height: 18px;
  color: white;
`;

const FeaturesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-radius: 12px;

  @media (max-width: 768px) {
    padding-top: 16px;
    gap: 8px;
  } 

    @media (max-height: 700px) {
    padding-top: 8px;
    gap: 4px;
  }
`;

const ChevronContainer = styled.div<IChevronContainerProps>`
  transform: ${({ isExpanded }) => isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'};
  transition: transform 0.3s;
`;
